function decodificarExpiracaoJWT(token) {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        const payload = JSON.parse(jsonPayload);

        if (payload.exp) {
            const data = new Date(payload.exp * 1000);
            return data.toLocaleString(); // Retorna string formatada
        }

        return "Token não possui campo exp";
    } catch (e) {
        return "Token inválido";
    }
}

export { decodificarExpiracaoJWT };
